<template>
  <!--会员中心-->
  <ZhaiHead></ZhaiHead>

  <!-- 九宫格 -->
  <div class="container-fluid zhu mb-2">
    <ZhaiJiuGong menu="1"></ZhaiJiuGong>
  </div>

  <!-- 隐藏挂载 -->
  <div class="banner-probe" v-if="getUser">
    <VipUpgradeDiffBanner
        ref="vipDiffBanner"
        :user-id="getUser && getUser.id"
        :text-prefix="memberUpgradePrefix"
        @select="handleSelectPermanentUpgrade"
    />
  </div>

  <!-- 补差价红条：参考首页组件的展示方式 -->
  <div
      v-if="getUser && showUpgradeBanner"
      class="container-fluid px-0"
  >
    <div class="member-diff-banner-wrap" @click="triggerBannerClick">
      <div class="member-diff-banner-text">
        {{ fullBannerText }}
      </div>
    </div>
  </div>

  <!--主体内容-->
  <div class="container-fluid shengse" v-if="getUser">
    <!--会员名字-->
    <div class="row mt-1">
      <div class="dixian px-3 py-2 mb-1 d-flex justify-content-between">
        <div class="py-1">
          <span>欢迎登录：</span>&nbsp;{{ getUser.username }}
        </div>
      </div>
    </div>

    <div class="mx-2">
      <!--会员等级-->
      <div class="row py-2 hui">
        <div class="px-3 Profile d-flex align-items-center justify-content-start">
          <div class="La">会员等级：</div>
          <span class="niandu changlv">
                        <strong>
                            <template v-if="getUser.level_expire_date && new Date() > new Date(getUser.level_expire_date)">
                                （VIP已过期）
                            </template>
                            <template v-else>
                                {{ getUser.level }}
                            </template>
                        </strong>
                    </span>
        </div>
      </div>

      <!--到期时间-->
      <div class="row huiziti py-2">
        <div class="px-3 Profile d-flex align-items-center justify-content-start">
          <div class="La">VIP有效期：</div>
          <div class="niandu">
            <span>{{ formatExpireDate(getUser.level_expire_date) }}</span>
          </div>
        </div>
      </div>

      <!--支付记录明细-->
      <div class="huiziti py-2" v-if="!fetchFailed && userEvents.length > 0">
        <div>
          <div class="La px-1">支付订单：</div>
          <table class="layui-table">
            <colgroup>
              <col width="150">
              <col width="150">
              <col width="200">
              <col>
            </colgroup>
            <thead>
            <tr>
              <th>订单类型</th>
              <th>支付金额</th>
              <th>支付时间</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(event, index) in userEvents" :key="index">
              <td>{{ event.event }}</td>
              <td>{{ event.price }}元</td>
              <td>{{ formatDate(event.create_time) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--VIP明细表格-->
      <div class="huiziti pt-2">
        <table class="table table-bordered" style="margin-top:10px;">
          <thead>
          <tr>
            <th scope="col">类型</th>
            <th scope="col">价格</th>
            <th scope="col">查看权限</th>
            <th scope="col">有效期</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>VIP月度会员</td>
            <td>¥188</td>
            <td>所有内容</td>
            <td>+1月度</td>
          </tr>
          <tr>
            <td>VIP年度会员</td>
            <td>¥288</td>
            <td>所有内容</td>
            <td>+1年</td>
          </tr>
          <tr>
            <td>VIP永久会员</td>
            <td>¥500</td>
            <td>所有内容</td>
            <td>永久</td>
          </tr>
          </tbody>
        </table>

        <div class="text-center my-3">
          <router-link to="/upgradeVIP" class="btn btn-primary">购买VIP</router-link>
        </div>
      </div>
    </div>
  </div>

  <ZhaiFoot></ZhaiFoot>

  <!-- 升级支付 模态框 -->
  <div class="modal fade" id="upgradeModal" tabindex="-1" aria-labelledby="upgradeModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="upgradeModalLabel">升级支付</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body" style="line-height:30px;">
          <div id="step1">
            <div>
              请选择支付宝或微信支付，请确认升级的VIP类型及支付金额是否正确，点击“支付”进行支付。
            </div>
            <div class="mt-2">
              <strong>升级类型：</strong>
              <span id="uplevel">{{ modalData.type }}</span>
            </div>
            <div class="mt-2">
              <strong>支付金额：</strong>
              <span id="payamount">{{ modalData.amount }}元</span>
            </div>
            <div class="mt-2 pay-method-row">
              <strong class="pay-method-title">支付方式：</strong>
              <div class="pay-method-options">
                <label class="pay-option">
                  <input type="radio" name="paytype" value="alipay" v-model="payType" id="alipay">
                  <span>支付宝</span>
                </label>
<!--                <label class="pay-option">-->
<!--                  <input type="radio" name="paytype" value="wechat" v-model="payType" id="wechat">-->
<!--                  <span>微信（备用）</span>-->
<!--                </label>-->
              </div>
            </div>
            <div class="mt-2" style="color:red;">
              如果支付加载不出来，多试几次就成功了。
            </div>
            <div class="text-center mt-5 d-flex justify-content-center gap-4">
              <button
                  id="startPayBtn"
                  class="btn btn-success"
                  @click="startPayment"
              >
                支付
              </button>

              <button
                  class="btn btn-success"
                  data-bs-dismiss="modal"
              >
                关闭
              </button>
            </div>
          </div>

          <div id="step2" style="display:none;">
            <!-- 支付结果直接显示在二维码区域内 -->
            <transition name="payment-notice">
              <div
                  v-if="paymentNotice.visible"
                  class="payment-inline-notice"
                  :class="{
                                        'payment-inline-success': paymentNotice.type === 'success',
                                        'payment-inline-error': paymentNotice.type === 'error'
                                    }"
              >
                <i
                    v-if="paymentNotice.type === 'success'"
                    class="bi bi-check-circle-fill payment-notice-icon"
                ></i>
                <i
                    v-else
                    class="bi bi-emoji-frown payment-notice-icon"
                ></i>
                <span>{{ paymentNotice.message }}</span>
              </div>
            </transition>

            <div id="paymsg" style="color: #00c26f;text-align: center;font-size: 1rem;font-weight: bold;"></div>
            <p id="code_msg" style="text-align: center;background: #040404;color: #ffeb00;font-size: 1rem;">
              如页面出现支付步骤文字说明，请务必看完（尤其是付款注意事项）再进行支付。
            </p>
            <p style="text-align: center;font-size: 1rem;color: #000;">
              请确认支付完成后，再点击“支付完成”
            </p>
            <div class="text-center d-flex justify-content-center gap-4">
              <button
                  id="btnpaysucess"
                  class="btn btn-primary"
                  @click="onManualCheckPayment"
              >
                支付完成
              </button>

              <button
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
              >
                关闭
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 时间限制提示模态框 -->
  <div class="modal fade" id="timeRestrictionModal" tabindex="-1" aria-labelledby="timeRestrictionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 350px;">
      <div class="modal-content">
        <div class="modal-body d-flex align-items-center justify-content-center">
          <i class="bi bi-clock" style="font-size: 2rem; color: red;"></i>
          <p class="mb-0 ms-2" id="timeRestrictionMessage" style="font-size: 1rem; color: red;"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZhaiHead from "../components/ZhaiHead";
import ZhaiFoot from "../components/ZhaiFoot";
import ZhaiJiuGong from "../components/ZhaiJiuGong";
import VipUpgradeDiffBanner from "../components/VipUpgradeDiffBanner.vue";
import { mapGetters } from "vuex";
import http from "../utils/http.js";
import { Modal } from "bootstrap";
import QRCode from "qrcodejs2";

export default {
  name: "MMemberCenter",
  components: {
    ZhaiHead,
    ZhaiFoot,
    ZhaiJiuGong,
    VipUpgradeDiffBanner
  },

  data() {
    return {
      userEvents: [],
      fetchFailed: false,

      modalData: { type: "", amount: 0 },
      payType: "alipay",
      orderId: null,
      manualPolling: false,

      paymentNotice: {
        visible: false,
        type: "",
        message: ""
      },
      paymentNoticeTimer: null,

      // 补差价红条显示状态：与隐藏的 VipUpgradeDiffBanner 保持同步
      showUpgradeBanner: false,
      bannerSyncTimer: null
    };
  },

  computed: {
    ...mapGetters(["getUser", "isLoggedIn"]),

    memberUpgradePrefix() {
      const username = this.getUser?.username || "会员";
      return `尊敬的会员 ${username}：限时补差价 `;
    },

    fullBannerText() {
      const banner = this.$refs.vipDiffBanner;
      if (!banner || !banner.upgradeInfo) return "";

      const username = this.getUser?.username || "会员";
      const price = banner.displayPrice(banner.upgradeInfo.upgradePrice);
      const countdown = banner.countdownText || "";

      return `尊敬的会员 ${username}：限时补差价 ${price}元，即可升级为永久会员！${countdown ? `（剩余${countdown}）` : ""}`;
    }
  },

  methods: {
    startBannerSync() {
      this.stopBannerSync();

      this.bannerSyncTimer = setInterval(() => {
        const banner = this.$refs.vipDiffBanner;
        if (!banner) {
          this.showUpgradeBanner = false;
          return;
        }

        this.showUpgradeBanner = !!banner.visible;
      }, 500);
    },

    stopBannerSync() {
      if (this.bannerSyncTimer) {
        clearInterval(this.bannerSyncTimer);
        this.bannerSyncTimer = null;
      }
    },

    triggerBannerClick() {
      const banner = this.$refs.vipDiffBanner;
      if (banner && typeof banner.handleClick === "function") {
        banner.handleClick();
      }
    },

    // 点击红条后直接弹支付框
    handleSelectPermanentUpgrade(payload) {
      this.modalData.type = payload.type;
      this.modalData.amount = payload.amount;
      this.openModal();
    },

    fetchUserEventInfo() {
      if (!this.getUser || !this.getUser.id) {
        console.error("用户未登录");
        return;
      }

      const userId = this.getUser.id;
      const url = `/platform/frontEnd/getUserEventInfo?userid=${userId}`;

      http.get(url)
          .then(response => {
            if (response.data && response.data.status === 1) {
              this.userEvents = response.data.data;
              this.fetchFailed = false;
            } else {
              this.fetchFailed = true;
              console.error("获取用户支付记录失败:", response.data.msg);
            }
          })
          .catch(error => {
            this.fetchFailed = true;
            console.error("API 请求错误:", error);
          });
    },

    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    formatExpireDate(date) {
      if (!date) {
        return "无";
      }

      const now = new Date();
      const expireDate = new Date(date);

      if (now > expireDate) {
        return "无";
      }

      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    showTimeRestrictionModal(message) {
      document.getElementById("timeRestrictionMessage").innerText = message;
      const timeModal = new Modal(document.getElementById("timeRestrictionModal"));
      timeModal.show();

      setTimeout(() => {
        timeModal.hide();
      }, 5000);
    },

    openModal() {
      this.hidePaymentNotice();
      this.orderId = null;
      this.manualPolling = false;

      document.getElementById("step1").style.display = "block";
      document.getElementById("step2").style.display = "none";

      const paymsg = document.getElementById("paymsg");
      if (paymsg) {
        paymsg.innerHTML = "";
      }

      const modalElement = document.getElementById("upgradeModal");
      const modalInstance = Modal.getOrCreateInstance(modalElement);
      modalInstance.show();
    },

    resetPayButton() {
      const payButton = document.getElementById("startPayBtn");
      if (payButton) {
        payButton.textContent = "支付";
        payButton.disabled = false;
      }
    },

    startPayment() {
      this.hidePaymentNotice();
      this.orderId = null;
      this.manualPolling = false;

      const payButton = document.getElementById("startPayBtn");
      if (payButton) {
        payButton.textContent = "生成中";
        payButton.disabled = true;
      }

      const { id: userid, username, email } = this.getUser || {};
      if (!userid || !username || !email) {
        this.resetPayButton();
        alert("用户信息不完整，请重新登录！");
        return;
      }

      let requestUrl = "";

      if (this.modalData.type === "限时补差价升级永久会员") {
        requestUrl = `/platform/frontEndPayment/requestPermanentUpgrade?userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
      } else {
        requestUrl = `/platform/frontEndPayment/request?name=${encodeURIComponent(this.modalData.type)}&money=${this.modalData.amount}&userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
      }

      http.get(requestUrl)
          .then(response => {
            const res = response.data;

            if (res && res.status === 1 && res.data) {
              const { payUrl, mchOrderNo } = res.data;

              if (!payUrl) {
                this.resetPayButton();
                this.showFailureModal("支付链接为空，请联系管理员！");
                return;
              }

              this.orderId = mchOrderNo;
              this.generateQRCode(payUrl);
            } else {
              this.resetPayButton();
              const errorMessage = res?.msg || "未知错误";
              this.showFailureModal(`支付请求失败：${errorMessage}`);
            }
          })
          .catch(error => {
            this.resetPayButton();
            this.showFailureModal(`请求支付失败，请重试。错误详情: ${error.message}`);
          });
    },

    generateQRCode(payUrl) {
      if (this.payType === "wechat") {
        document.getElementById("paymsg").innerHTML =
            "截图并保存二维码，然后使用微信扫一扫付款。";
      } else {
        document.getElementById("paymsg").innerHTML =
            "请用手机相机扫描下方二维码，从浏览器打开，将自动跳转支付宝支付。也可截图并保存二维码，然后使用支付宝扫一扫付款。";
      }

      const qrCodeContainer = document.createElement("div");
      qrCodeContainer.id = "qrcode";
      qrCodeContainer.style.width = "200px";
      qrCodeContainer.style.height = "200px";
      qrCodeContainer.style.marginTop = "20px";

      document.getElementById("paymsg").appendChild(qrCodeContainer);

      new QRCode(qrCodeContainer, {
        text: payUrl,
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });

      document.getElementById("step1").style.display = "none";
      document.getElementById("step2").style.display = "block";

      let remainingTime = 300;

      const countdown = document.createElement("p");
      countdown.id = "countdown";
      countdown.style.textAlign = "center";
      countdown.style.marginTop = "10px";
      countdown.style.fontWeight = "normal";
      countdown.style.color = "rgba(255, 127, 127)";
      countdown.style.fontSize = "0.9rem";
      document.getElementById("paymsg").appendChild(countdown);

      const timer = setInterval(() => {
        if (remainingTime <= 0) {
          clearInterval(timer);
          countdown.innerHTML = "支付已超时，请关闭重新选择支付！";
          qrCodeContainer.style.filter = "blur(5px)";
          this.resetPayButton();
        } else {
          const minutes = Math.floor(remainingTime / 60);
          const seconds = remainingTime % 60;
          countdown.innerHTML = `请在 ${minutes}:${seconds < 10 ? "0" + seconds : seconds} 内完成支付`;
          remainingTime--;
        }
      }, 1000);
    },

    onManualCheckPayment() {
      this.hidePaymentNotice();
      this.manualPolling = true;
      this.checkPaymentStatus();
    },

    checkPaymentStatus() {
      if (!this.orderId) {
        this.showFailureModal("订单号不存在，请重新发起支付");
        return;
      }

      const statusUrl =
          `/platform/frontEndPayment/checkPaymentStatus?outTradeNo=${encodeURIComponent(this.orderId)}`;

      http.get(statusUrl)
          .then(response => {
            const data = response.data;

            if (data && data.status === 1) {
              this.manualPolling = false;
              this.handlePaymentSuccessStatus();
            } else {
              this.showFailureModal("未检测到支付完成，请稍后重试");
            }
          })
          .catch(error => {
            console.error("查询支付状态异常:", error);
            this.showFailureModal("查询支付状态失败，请稍后重试");
          });
    },

    handlePaymentSuccessStatus() {
      this.$store.dispatch("checkLoginStatus");
      this.fetchUserEventInfo();

      if (this.$refs.vipDiffBanner) {
        this.$refs.vipDiffBanner.refresh();
      }

      this.showSuccessModal("支付已成功");
    },

    showPaymentNotice(type, message, duration = 3000) {
      if (this.paymentNoticeTimer) {
        clearTimeout(this.paymentNoticeTimer);
        this.paymentNoticeTimer = null;
      }

      this.paymentNotice = {
        visible: true,
        type,
        message
      };

      if (duration > 0) {
        this.paymentNoticeTimer = setTimeout(() => {
          this.hidePaymentNotice();
        }, duration);
      }
    },

    hidePaymentNotice() {
      if (this.paymentNoticeTimer) {
        clearTimeout(this.paymentNoticeTimer);
        this.paymentNoticeTimer = null;
      }

      this.paymentNotice.visible = false;
      this.paymentNotice.type = "";
      this.paymentNotice.message = "";
    },

    // 成功提示显示在二维码区域，2秒后关闭支付框并刷新会员中心
    showSuccessModal(message) {
      this.showPaymentNotice("success", message, 0);

      setTimeout(() => {
        const upgradeElement = document.getElementById("upgradeModal");
        const upgradeModal = Modal.getInstance(upgradeElement);

        if (upgradeModal) {
          upgradeModal.hide();
        }

        window.location.reload();
      }, 2000);
    },

    // 失败提示显示在二维码区域，支付框和二维码保持不变
    showFailureModal(message) {
      this.showPaymentNotice("error", message, 3000);
    }
  },

  watch: {
    isLoggedIn(val) {
      if (!val) {
        this.$router.push("/login");
      }
    }
  },

  created() {
    this.fetchUserEventInfo();
  },

  mounted() {
    this.startBannerSync();
  },

  beforeUnmount() {
    this.stopBannerSync();
    this.hidePaymentNotice();
  }
};
</script>

<style scoped>
.gongxi {
  height: 90px;
}

/* 隐藏挂载点不占页面空间 */
.banner-probe {
  position: absolute;
  left: -99999px;
  top: -99999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  pointer-events: none;
}

/* 真正显示在会员中心页面上的补差价红条 */
.member-diff-banner-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 6px;
  margin-bottom: 6px;
}

.member-diff-banner-text {
  display: block;
  width: 100%;
  background: #ffffff;
  color: #ff2b2b;
  padding: 5px 5px;
  border-radius: 0;
  font-size: 0.98rem;
  font-weight: 600;
  line-height: 1.8;
  box-sizing: border-box;
  cursor: pointer;
}

.layui-table {
  width: 100%;
  background-color: #fff;
  color: #666;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-collapse: collapse;
}

.layui-table th,
.layui-table td {
  border: 1px solid #ddd;
  text-align: center;
  vertical-align: middle;
  line-height: 2rem;
}

.layui-table th {
  font-weight: normal;
  background-color: #f2f2f2;
}

.btn-primary {
  color: #fff;
  background-color: #00c26f;
  margin-bottom: 1rem !important;
  margin-top: 1rem !important;
  border: none !important;
}

.table td,
.table th {
  text-align: center;
  vertical-align: middle;
}

.table th {
  background-color: #d5d5d5;
}

.zhu {
  margin-top: 80px;
}

#paymsg {
  color: #00c26f;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#qrcode {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: filter 0.5s ease;
}

#countdown {
  font-size: 0.7rem;
  color: red !important;
  text-align: center;
  margin-bottom: 0 !important;
}

#btnpaysucess,
.modal-body .btn-primary,
.btn-success {
  background-color: #00c26f !important;
  border: none !important;
}

.pay-method-row {
  display: flex;
  align-items: flex-start;
}

.pay-method-title {
  flex-shrink: 0;
  line-height: 30px;
}

.pay-method-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pay-option {
  display: flex;
  align-items: center;
  margin: 0;
  line-height: 30px;
  white-space: nowrap;
  cursor: pointer;
}

.pay-option input[type="radio"] {
  margin: 0 7px 0 0;
  flex-shrink: 0;
}


.payment-inline-notice {
  width: 100%;
  margin: 0 auto 12px;
  padding: 10px 12px;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
}

.payment-inline-success {
  color: #07894f;
  background-color: #e9fff5;
  border: 1px solid #00c26f;
}

.payment-inline-error {
  color: #dc3545;
  background-color: #fff1f2;
  border: 1px solid #f1aeb5;
}

.payment-notice-icon {
  flex-shrink: 0;
  font-size: 1.3rem;
}

.payment-notice-enter-active,
.payment-notice-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.payment-notice-enter-from,
.payment-notice-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.payment-notice-enter-to,
.payment-notice-leave-from {
  opacity: 1;
  transform: translateY(0);
}

#timeRestrictionModal .modal-dialog {
  margin: 2% auto !important;
  max-width: 350px;
}
</style>
